import MainNavMenu from '../../../menus/MainNavMenu/MainNavMenu'
import { useEffect, useState } from 'react'
import AlertModal from './AlertModal'
import { deleteEvent, deleteSensorEvent, getAllEvents, getAllSensorEvents, getHazardName } from '../AlertingSlice/AlertingSlice'
import getActiveEvents from '../AlertingSlice/getActiveAlerts'
import dayjs from 'dayjs'
import messagealert from '../../../assets/message-alert-square.svg'
import infoIcon from '../../../assets/icons/infoIcon.svg'
import useErrorStatus from '../../../hooks/UseErrorStatus'

function AlertsPage() {
  const [showModal, updateShowModal] = useState(false)
  const [formBool, setForm] = useState(true)
  const [prefillData, setPrefillData] = useState({})

  const toggleModal = (isForm : boolean = false, preFill : any = {}) => {
    updateShowModal((state) => !state)
    setForm(isForm)
    setPrefillData(preFill)
  }
  const notificationBox = useErrorStatus()

  const formatDate = (date: string) => {
    const formatted = dayjs(date).format('MMM D - h:mm A')
    return formatted
  }

  const [eventsData, setEventsData] = useState([])
  const [alertsData, setAlertsData] = useState([])

  const fetchEventInformation = async () => {
    const userEvents = await getAllEvents()
    const sensorSpecificMonitors = await getAllSensorEvents()

    setEventsData([...userEvents, ...sensorSpecificMonitors])

    const userAlerts = await getActiveEvents()
    setAlertsData(userAlerts[0])
  }

  const deleteUserEvent = async (eventName: string, eventID: string, sensorSpecific: boolean) => {
    if (confirm('Delete this Monitor?')) {
      if(sensorSpecific) await deleteSensorEvent(eventID)
      else await deleteEvent(eventName)
      setEventsData((prev) =>
        prev.filter((event) => event.eventName != eventName)
      )
      setAlertsData((prev) => 
        prev.filter((alert) => alert?.properties?.triggerEvent != eventName)
      )
      notificationBox.addMessage( 'Monitor successfully deleted.', 400, 'info', false, 10 * 1000)
    }
  }

  useEffect(() => {
    fetchEventInformation()
  }, [])

  return (
    // Screen div
    <div className="flex items-center p-4 w-full bg-[#F1F5F9] overflow-y-clip">
      {/* Parent div for encompassing all the data*/}
      <div className="flex flex-col m-4 w-full rounded-lg bg-[#F8F8F8] h-full border border-[#94a3b8] px-4">
        {/* Title div and back button */}
        <div className="flex flex-row p-2 items-center">
          <MainNavMenu />
          <div className="text-xl text-[#1e293b] uppercase absolute left-1/2 transform -translate-x-1/2 font-semibold">
            Monitoring - Alerting Dashboard
          </div>
        </div>
        <div className="flex items-center justify-center">
          <img src={messagealert} className="w-10 h-10" />
          <p className="text-sm font-semibold text-gray-600 antialiased uppercase text-[#64748B]">
            Monitors let you define custom weather thresholds—like wind speed, visibility, or temperature. 
            When those thresholds are crossed, you’ll receive alerts right away.
          </p>
        </div>
        <hr />
        <div className="p-2 gap-2 grid grid-cols-1 md:grid-cols-2">
          {/* Events display */}
          <div>
            {/* Label Information for active alerts and vreate new event option */}
            <div className="flex flex-row p-2 items-center gap-2 justify-between ">
              <div className="flex text-base rounded-2xl h-full p-2 font-semibold text-[#1e293b] uppercase">
                Active Monitors
              </div>
              <div className="flex flex-col text-lg rounded-2xl h-full font-semibold">
                <button onClick={() => {toggleModal(true)}} className="flex flex-1 flex-1 border border-[#94a3b8] p-2 rounded-lg text-base hover:bg-[#cbd5e1] text-[#1e293b] uppercase">
                  + Create new Monitor
                </button>
              </div>
            </div>

            {eventsData.length == 0 ? (
              <div className="flex h-20 bg-[#FFF9DB] text-[#7C6E00] rounded-lg items-center justify-center text-lg uppercase font-bold border-[#7C6E00] border ">
                No Monitors Created !
              </div>
            ) : (
              <div className="relative border border-[#94a3b8] rounded-lg h-auto max-h-[30vh] sm:max-h-[40vh] md:max-h-[65vh] overflow-y-auto">
                {/* Header */}
                <div className="flex flex-row items-center uppercase gap-2 bg-[#cbd5e1] rounded-t-lg p-2 text-base text-[#1e293b] divide-x divide-[#94a3b8] font-semibold sticky top-0">
                  <div className="flex-1 text-center">Monitor Name</div>
                  <div className="flex-1 text-center">Start Time</div>
                  <div className="flex-1 text-center">End Time</div>
                  <div className="flex-1 text-center">Location</div>
                  {/* Placeholder to have consistent spacing */}
                  <div className='flex flex-row gap-1 invisible'>
                    <div className="flex text-center h-6 w-6" />
                    <div className="flex text-center h-6 w-6" />
                  </div>
                </div>

                {/* Event data rows */}
                <div className="flex flex-col divide-y divide-gray-300 mt-2 h-auto">
                  {eventsData.map((item, index) => (
                    <div className="flex flex-row p-2 items-center gap-2 text-sm text-[#1e293b]">
                      <div className="flex-1 text-center text-base">{item.eventName}</div>
                      <div className="flex-1 text-center">
                        {formatDate(item.startTime)}
                      </div>
                      <div className="flex-1 text-center">
                        {formatDate(item.endTime)}
                      </div>
                      <div className="flex-1 text-center uppercase">{item.location}</div>
                      <div className='flex flex-row gap-1'>
                        <button
                          className="flex text-center h-6 w-6 border text-base items-center justify-center rounded-lg bg-[#D6F0FF] text-blue-900 hover:bg-blue-200"
                           onClick={() => {toggleModal(false, item)}}>
                          <img src={infoIcon} alt="Icon" />
                        </button>
                        <button
                          className="flex text-center h-6 w-6 border text-base items-center justify-center rounded-lg bg-[#FFE5E5] text-[#A03333] hover:bg-[#FFCCCC]"
                          onClick={() => deleteUserEvent(item.eventName, item.eventID, item.sensorID != undefined, )}
                        >
                          {' '}&#x2715;{' '}
                        </button>
                      </div>
                    </div>                    
                  ))}
                </div>
              </div>
            )}
          </div>  
          <AlertModal canShow={showModal} updateModalState={toggleModal} parentSetter={setEventsData} form={formBool} preFillData={prefillData}/>

          {/* Alerts display */}
          <div>
            {/* Label Information for active alerts and vreate new event option */}
            <div className="flex flex-row p-2 items-center gap-2 justify-between ">
              <div className="flex text-base rounded-2xl h-full p-2 font-semibold text-[#1e293b] uppercase">
                Active Alerts
              </div>
              {
                alertsData.length > 1 &&
                <div className="flex text-base rounded-lg h-full p-2 font-semibold text-[#1e293b] uppercase border bg-[#FF5F15]/20 animate-pulse-border">
                  Alerts : {alertsData.length}
                </div>
              }
            </div>

            {alertsData.length == 0 ? (
              <div className="flex h-20 bg-[#FFF9DB] text-[#7C6E00] rounded-lg items-center justify-center text-lg uppercase font-bold border-[#7C6E00] border ">
                No Alerts generated !
              </div>
            ) : (
              <div className="border border-[#94a3b8] rounded-lg h-auto max-h-[30vh] sm:max-h-[40vh] md:max-h-[65vh] overflow-y-auto">
                {/* Header */}
                <div className="flex flex-row items-center uppercase gap-2 bg-[#cbd5e1] rounded-t-lg p-2 text-base text-[#1e293b] divide-x divide-[#94a3b8] font-semibold  sticky top-0">
                  <div className="flex-1 text-center">Alerted Monitor</div>
                  <div className="flex-1 text-center">Alert Time</div>
                  <div className="flex-1 text-center">Hazard</div>
                  <div className="flex-1 text-center">Source</div>
                </div>

                {/* Alerts data rows */}
                <div className="flex flex-col divide-y divide-gray-300 mt-2">
                  {alertsData.map((item, index) => (
                    <div className="flex flex-row p-2 items-center gap-2 text-sm text-[#1e293b]">
                      <div className="flex-1 text-center text-base">
                        {item.properties.triggerEvent}
                      </div>
                      <div className="flex-1 text-center">
                        {formatDate(item.properties.expires)}
                      </div>
                      <div className="flex-1 text-center font-semibold uppercase border bg-[#FFEBD1] text-[#A85C00] rounded-lg justify-center">
                        {getHazardName(item.properties.hazardType)}
                      </div>
                      <div className="flex-1 text-center uppercase font-semibold">
                        {item.properties?.sensorType && item.properties?.stationName
                        ? `${item.properties.sensorType} - ${item.properties.stationName}`
                        : "Model"}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default AlertsPage
